import React from "react";

const Page = ({ children, classes }) => {
  return (
    <div
      className={`w-full max-w-screen-lg opacity-95 mx-auto pt-16 pb-0 bg-primary ${classes}`}
    >
      {children}
    </div>
  );
};

export default Page;
